var _defs, _rect, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew256({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.66,
    y: 5.24,
    width: 7.34,
    height: 5.52
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.6 8.67 8 8.67 8 5.24 15.34 5.24 13.6 8.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.91,13.31a2,2,0,0,1-.84.15,1.5,1.5,0,0,1-1.58-1.62,1.59,1.59,0,0,1,1.67-1.68,1.64,1.64,0,0,1,.76.15l-.1.33a1.62,1.62,0,0,0-.65-.13,1.19,1.19,0,0,0-1.25,1.32,1.17,1.17,0,0,0,1.23,1.29,1.71,1.71,0,0,0,.68-.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.28,13.42v-.26l.33-.32c.79-.75,1.14-1.15,1.15-1.61a.55.55,0,0,0-.62-.61,1.05,1.05,0,0,0-.65.27l-.13-.3a1.35,1.35,0,0,1,.87-.31.86.86,0,0,1,.94.89c0,.57-.41,1-1.06,1.66l-.24.23h1.38v.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew256);
export default __webpack_public_path__ + "static/media/Symbolpack_New_256.649306afb06892130d15ab3150685ff4.svg";
export { ForwardRef as ReactComponent };